/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_FallbacksInputs */

const en_svchip_fallbacks = /** @type {(inputs: Svchip_FallbacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallbacks`)
};

const ar_svchip_fallbacks = /** @type {(inputs: Svchip_FallbacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البدائل`)
};

const bn_svchip_fallbacks = /** @type {(inputs: Svchip_FallbacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফলব্যাক`)
};

const de_svchip_fallbacks = /** @type {(inputs: Svchip_FallbacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallbacks`)
};

const es_svchip_fallbacks = /** @type {(inputs: Svchip_FallbacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas`)
};

const fr_svchip_fallbacks = /** @type {(inputs: Svchip_FallbacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solutions de repli`)
};

const pt_svchip_fallbacks = /** @type {(inputs: Svchip_FallbacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternativos`)
};

const zh_svchip_fallbacks = /** @type {(inputs: Svchip_FallbacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后备`)
};

const tr_svchip_fallbacks = /** @type {(inputs: Svchip_FallbacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri dönüşler`)
};

const ru_svchip_fallbacks = /** @type {(inputs: Svchip_FallbacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Резервные варианты`)
};

const pl_svchip_fallbacks = /** @type {(inputs: Svchip_FallbacksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwy awaryjne`)
};

/**
* | output |
* | --- |
* | "Fallbacks" |
*
* @param {Svchip_FallbacksInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_fallbacks = /** @type {((inputs?: Svchip_FallbacksInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_FallbacksInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_fallbacks(inputs)
	if (locale === "bn") return bn_svchip_fallbacks(inputs)
	if (locale === "de") return de_svchip_fallbacks(inputs)
	if (locale === "es") return es_svchip_fallbacks(inputs)
	if (locale === "fr") return fr_svchip_fallbacks(inputs)
	if (locale === "pt") return pt_svchip_fallbacks(inputs)
	if (locale === "zh") return zh_svchip_fallbacks(inputs)
	if (locale === "tr") return tr_svchip_fallbacks(inputs)
	if (locale === "ru") return ru_svchip_fallbacks(inputs)
	if (locale === "pl") return pl_svchip_fallbacks(inputs)
	return en_svchip_fallbacks(inputs)
});